/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'routeContentTrees',
		'routeContentTrees'
	],

	config: {
		mode: 'chooser',
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeContentTrees',
				'chooseRouteContentTree'
			]
		},
		nodeActionMapping: {
			defaultBaseActions: {
				select: {
					layout: 'choose_layout',
					section: 'choose_section',
					component: 'choose_component'
				},
				deselect: {
					layout: 'choose_layout',
					section: 'choose_section',
					component: 'choose_component'
				}
			}
		}
	},

	methods: {
		dataDealer: function(){
			// TODO: sectionIDs are not unique over different routes!
			// this.model.highlightSectionIDs 			= this.getResourceRegisterContent('highlightSectionIDs') || {};
			this.model.highlightRouteComponentIDs 	= this.getResourceRegisterContent('highlightRouteComponentIDs') || {};
			this.model.decisionOptions 				= this.getResourceRegisterContent('onRouteContentChosenDecisionOptions') || {};

			this.model.moveSource 					= this.getResourceRegisterContent('moveSource') || {};
		},

		choose: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self = this;

			// move to is some sort of special case where this component performs all necessary further actions.
			if(utils.collectionSize(self.model.moveSource) > 0){
				return self.moveTo(baseActionKey, buttonContext, buttonMode, actionBossComponent, data);
			}

			// trigger decision
			// NOTE: 	since the parent of this component is used for the choose workflow (either chooseRouteTrees or mblx-products-controller)
			// 			the parent is not allowed to decide what to do. but the next parent is.
			self.parent(function(parent){
				parent.triggerClosest('onDecision', {
					decisionComponent: 	self,
					decisionType: 		'submit',
					decisionOptions: 	utils.simpleMerge(self.config.decisionOptions || {}, self.model.decisionOptions || {}, { wasMassInsert: utils.keyboard.keysActive('strg') }),
					data: 				self.getSelectedNodeData() || {}
				});
			})

			self.deselectActiveNode();
		},

		moveTo: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self 		= this;
			var nodeData 	= self.getSelectedNodeData() || {};
			var moveSource 				= self.model.moveSource || {};
			var moveTargetRouteID 		= (self.getResourceRegisterContent('routeTreeParent') || {}).resourceID;
			var moveAttributes 			= false;

			// check for invalid move operation
			if(
				nodeData.type &&
				nodeData.primaryKey &&
				nodeData[nodeData.primaryKey] &&
				moveTargetRouteID === moveSource.routeID &&
				(((moveSource.invalidMoveTargets || {})[nodeData.type] || {})[nodeData.subType || 'default'] || {})[nodeData[nodeData.primaryKey]]
			){
				self.deselectActiveNode();
				return self.performAction(
					self.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:routeContentTree.moveToAnotherRoute.sourceToTargetDependency'
						}
					})
				);
			}

			var statusController;
			if((statusController = getComponent('statusController'))){
				statusController.showStatus('status.progress.move')
			}

			if(moveTargetRouteID && moveSource.routeComponentID){
				if(buttonContext === 'component' && nodeData.routeComponentID){
					moveAttributes = {
						routeComponentID: 		moveSource.routeComponentID,
						sourceRouteID:			moveSource.routeID || 0,
						targetRouteID:			moveTargetRouteID,
						parentRouteComponentID: nodeData.parentRouteComponentID || 0,
						sectionID: 				nodeData.sectionID || 0,
						sort: 					(nodeData.sort || 0) + 1
					};
				} else if (buttonContext === 'section' && nodeData.sectionID){
					var parentRouteComponentID = 0;
					if(nodeData.type === 'section' && nodeData.parentType === 'routeComponent') {
						parentRouteComponentID = nodeData.parentID;
					}

					moveAttributes = {
						routeComponentID: 		moveSource.routeComponentID,
						sourceRouteID:			moveSource.routeID || 0,
						targetRouteID:			moveTargetRouteID,
						parentRouteComponentID: parentRouteComponentID,
						sectionID: 				nodeData.sectionID || 0,
						sort: 					0
					};

				} else if (buttonContext === 'layout'){
					moveAttributes = {
						routeComponentID: 		moveSource.routeComponentID,
						sourceRouteID:			moveSource.routeID || 0,
						targetRouteID:			moveTargetRouteID,
						parentRouteComponentID: 0,
						sectionID: 				nodeData.sectionID || 0,
						sort: 					nodeData.sort || 0
					};
				}
			}

			if(moveAttributes){
				return self.performAction(
					self.prepareAction('move_routeComponent', undefined, undefined, {
						source: {
							submit: {
								data: {
									resourceFilters: moveAttributes
								}
							}
						}
					})
				).then(function(context){
					if(statusController) statusController.removeStatus();
					moveAttributes.success = true;
					moveAttributes.component = self;
					return self.triggerClosest('onRouteComponentMovedToAnotherRoute', moveAttributes);
				}).fail(function(error){
					if(statusController) statusController.removeStatus();
					moveAttributes.success 		= false;
					moveAttributes.error 		= error;
					moveAttributes.component 	= self;
					return self.triggerClosest('onRouteComponentMovedToAnotherRoute', moveAttributes);
				});
			}

			self.deselectActiveNode();
			return self.performAction(
				self.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:routeContentTree.moveToAnotherRoute.common'
					}
				})
			);
		}
	}
};
